import React, { useState } from "react";
import { Typography } from "@material-ui/core";
import { GlobalHotKeys } from "react-hotkeys";

const BaseKeyListener = ({ items, onSelected }) => {
	const [lastKeys, setLastKeys] = useState([]);

	// Keystrokes that can automatically transition
	const autoKeys = [];
	let longestKeyStroke = 0;

	items.forEach((t) => {
		const { keyStroke } = t;
		if (keyStroke) {
			const isManual = items.some(
				(transition) =>
					transition.keyStroke !== keyStroke &&
					transition.keyStroke?.slice(0, keyStroke.length) === keyStroke
			);
			if (!isManual) {
				autoKeys.push(keyStroke.toUpperCase());
				autoKeys.push(keyStroke.toLowerCase());
			}
			longestKeyStroke = Math.max(keyStroke.length, longestKeyStroke);
		}
	});

	const keyMap = {
		SELECTION: [
			..."abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
		],
		ENTER: ["enter"],
		CLEAR: ["del"],
		DELETE: ["backspace"]
	};

	const handlers = {
		SELECTION: (event) => {
			const keyStroke = event.key.toUpperCase();
			const updatedLastKeys = [...lastKeys, keyStroke];
			const combinedKeys = updatedLastKeys.join("");

			if (autoKeys.some((ak) => ak === combinedKeys)) {
				const item = items.find((t) => t.keyStroke?.toUpperCase() === combinedKeys);
				if (item) {
					onSelected(item);
				}
				setLastKeys([]);
			} else if (updatedLastKeys.length >= longestKeyStroke) {
				setLastKeys([]);
			} else {
				setLastKeys(updatedLastKeys);
			}
		},
		ENTER: () => {
			const combinedKeys = lastKeys.join("");
			const transition = items.find(
				(t) => t.keyStroke?.toUpperCase() === combinedKeys
			);
			if (transition) {
				onSelected(transition);
			}
			setLastKeys([]);
		},
		CLEAR: () => {
			setLastKeys([]);
		},
		DELETE: () => {
			setLastKeys(lastKeys.slice(0, lastKeys.length - 1));
		}
	};

	return (
		<>
			{items.length > 0 && (
				<Typography variant="inherit">
					{`Type the corresponding hotkey(s) to select a Play: ${lastKeys.join(
						""
					)}...`}
				</Typography>
			)}
			<GlobalHotKeys keyMap={keyMap} handlers={handlers} allowChanges />
		</>
	);
};

export default BaseKeyListener;
